import React, { useEffect } from "react";
import "./Table.scss";
import Button from "../Button/Button";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Checkbox from "../Checkbox/Checkbox";

const TableItem = ({
	className,
	styles,
	img,
	data,
	buttons,
	showCheckBox = false,
	onClickCheckBox,
	checkBoxId,
	isButtons = false,
}) => {
	return (
		<div
			className={`table-item ${isButtons ? "button-container" : ""} ${className ? className : ""}`}
			style={styles}
		>
			{isButtons ? (
				<div className="flex direction-row align-items-center">
					{buttons.map((button) => {
						return (
							<Button
								className={`button-secondary ${button.buttonClass ? button.buttonClass : ""}`}
								icon={button.icon}
								iconOnly={true}
								onClick={button.onClick}
							/>
						);
					})}
				</div>
			) : (
				<div className="flex direction-row align-items-center">
					<div className="flex direction-row align-items-center">
						{showCheckBox ? (
							<input
								type="checkbox"
								id={checkBoxId}
								className="checkbox mr-8"
								name="checkbox"
								onChange={(e) => {
									onClickCheckBox(e);
								}}
							/>
						) : (
							<></>
						)}
						{img ? <img src={img} alt={`avatar`} /> : <></>}
					</div>
					{Array.isArray(data) ? (
						<ul>
							{data.map((d) => {
								return <li>{d}</li>;
							})}
						</ul>
					) : (
						<div className="text text-body--4 ml-8">{data}</div>
					)}
				</div>
			)}
		</div>
	);
};

export default TableItem;
